import React, { useState, useEffect, createContext, useContext } from "react";
import { EventType} from "../Models/EventType";
import { useEventType } from "./EventTypeProvider";
import { useAuthorization, IsAuthorized} from 'meportal/AuthorizationProvider';
import { useToast } from "./ToastProvider";
import {NOTIFICATION_TYPES} from '../components/ToastNotification/toastConstants';

 export type ViewEventTypeContextType = {
    viewEventTypes: EventType[];
  };

const ViewEventTypeContext = createContext<ViewEventTypeContextType | null>(null);

export const  ViewEventTypeProvider = ({ children, permission }) => {
  const { eventTypes } = useEventType();
  const {eventPermissions, userClaims, isHttpErrorEventPermissions} = useAuthorization();
  const { addToast } = useToast();

  const [ viewEventTypes, setViewEventTypes] = useState<EventType[]>([]);
  
    useEffect(() => { 
         if (Array.isArray(eventPermissions) && eventPermissions.length > 0 && 
            Array.isArray(userClaims) && userClaims.length > 0 && permission.length > 0) {
            if (Array.isArray(eventTypes) && eventTypes.length > 0) { 
              let viewable = eventTypes.filter((eventType) => {
              let ok = IsAuthorized(eventType.Airline + ":" + eventType.Name, permission, eventPermissions, userClaims);
              return ok;
             });
            setViewEventTypes(viewable);
            if(viewable && viewable.length === 0){
              addToast(NOTIFICATION_TYPES.WARNING,'You do not have permission to view event types.','Please contact a MOM.');
           }
          }
        }
      return () => {
        setViewEventTypes([]);
      };
    }, [eventPermissions, userClaims, permission, eventTypes]);

    useEffect(() => {
      if(isHttpErrorEventPermissions){
        addToast(NOTIFICATION_TYPES.WARNING, 'Failed to load event permissions.', 'Please contact support.');
      }
    }, [isHttpErrorEventPermissions]);

    return (
        <ViewEventTypeContext.Provider value={{ viewEventTypes }}>
            {children}
        </ViewEventTypeContext.Provider>
    );
}

// Custom hook that exposes the EventTypeContext
// Allows lower components to access EventTypeProvider's event types
export const useViewableEventTypes = () => {
  const context = useContext(ViewEventTypeContext);
  if (!context) {
    console.error(
      "useViewableEventTypes must be used within a ViewEventTypeProvider. Wrap a parent component in <EventTypeProvider> to fix this error."
    );
    return null; // or return some default value
  }
  return context;
};